/* eslint-disable max-len */
import React from 'react';
import { Item, TabList, Tabs } from '@adobe/react-spectrum';
import '../../styles/HeroBlade.scss';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

const HeroBlade = ({ isMobile, disableTabSelection }) => {
  const { pathname } = useLocation();
  const naviagte = useNavigate();
  const dispatch = useDispatch();
  const activeStyle = {
    textDecoration: 'none',
    color: 'var(--spectrum-global-color-gray-900)',
    fontWeight: 700,
  };

  const onSelectionChange = (data) => {
    naviagte(data);
  };
  return (
    <div className="cmp-heroBlade">
      <div style={{ marginTop: '40px' }}><h1>{pathname === '/solution' ? 'Adobe Solution Partner Directory' : 'Adobe Technology Partner Directory'}</h1></div>
      <div style={{ fontSize: '16px', margin: '0px 20px', maxWidth: '1300px' }}>
        {pathname === '/solution'
          ? 'Adobe partners with thousands of companies globally to offer clients services and offerings that span expertise, experience and geography. Search our database to find the right Experience or Document Cloud partner for your next project.'
          : 'Adobe’s Technology Partners are industry-leading companies that are leveraging Adobe Experience Cloud, Commerce Cloud, and Document Cloud solutions.'}
      </div>
      <div className="heroBlade-link-container">
        <a href={window.directoryConfig.adobePartnerDirectory} className="heroBlade-link" target="_blank" rel="noreferrer">
          View other Adobe partner directories
        </a>
      </div>
      <div className="tabsList" style={{ width: isMobile ? '350px' : '500px' }}>
        <div style={{ minWidth: isMobile ? '' : '300px' }}>
          <Tabs aria-label="Partners" className="tabs" onSelectionChange={onSelectionChange} defaultSelectedKey={pathname} orientation="horizontal">
            <TabList>
              <Item key="/solution" isDisabled={pathname !== '/solution' && disableTabSelection}>
                SOLUTION PARTNERS
              </Item>
              <Item key="/technology" isDisabled={pathname !== '/technology' && disableTabSelection}>
                TECHNOLOGY PARTNERS
              </Item>
            </TabList>
          </Tabs>
        </div>

      </div>
    </div>
  );
};

export default HeroBlade;
